module.exports = __webpack_public_path__ + "img/sld_mfm_og_t1_dark.b0da108b.svg";